import {Component, Input, OnInit} from '@angular/core';
import {FlagPipe} from '../../../pipes/flag.pipe';

@Component({
  selector: 'app-flag-cell',
  template: `
      <span [outerHTML]="value | flag" ></span>
  `,
  styleUrls: ['./flag-cell.component.scss']
})
export class FlagCellComponent implements OnInit {

    renderValue: string;

    @Input() value: string | number;
    @Input() rowData: any;

    constructor() { }

    ngOnInit() {
        this.renderValue = this.value.toString();
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/shared/components/smart-table/flag-cell/flag-cell.component.ts